export var TaskStatus;
(function (TaskStatus) {
    TaskStatus[TaskStatus["PREPARED"] = 0] = "PREPARED";
    TaskStatus[TaskStatus["RUNNING"] = 1] = "RUNNING";
    TaskStatus[TaskStatus["SUCCESS"] = 2] = "SUCCESS";
    TaskStatus[TaskStatus["ERROR"] = 3] = "ERROR";
    TaskStatus[TaskStatus["CANCELED"] = 4] = "CANCELED";
    TaskStatus[TaskStatus["REMOVED"] = 5] = "REMOVED";
})(TaskStatus || (TaskStatus = {}));
